'use client';

import { c as _c } from "react/compiler-runtime";
import { MdSearch } from 'react-icons/md';
export function SearchInput(t0) {
  const $ = _c(5);
  const {
    searchTerm,
    onSearchTermChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <label className="sr-only" htmlFor="project-search">Search projects</label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-5 text-gray-500 dark:text-gray-400"><MdSearch className="h-5 w-5" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onSearchTermChange || $[3] !== searchTerm) {
    t3 = <div className="relative w-full">{t1}{t2}<input id="project-search" name="project-search" autoComplete="off" spellCheck={false} type="search" placeholder={"Search projects\u2026"} value={searchTerm} onChange={onSearchTermChange} className="border-border-color text-content-text shadow-custom block w-full rounded-full border bg-(--bg) px-5 py-3 pl-12 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 focus:outline-hidden dark:placeholder-gray-500" /></div>;
    $[2] = onSearchTermChange;
    $[3] = searchTerm;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}